import React, { useState } from 'react'
import rightArrow from '../../Image/rightArrow.svg'
import slider1 from '../../Image/slider1.png'
import slider2 from '../../Image/slider2.png'
import slider3 from '../../Image/slider3.png'
import slider4 from '../../Image/slider4.png'
import slider5 from '../../Image/slider5.png'
import Wave from 'react-wavify'
import { animate } from 'animejs';
import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom'


const Slider = () => {
  const root = useRef(null);
  const navigate = useNavigate();
  const dragRef1 = useRef(null);
  const dragRef2 = useRef(null);
  const dragRef3 = useRef(null);
  const dragRef4 = useRef(null);
  const dragRef5 = useRef(null);
  useEffect(() => {
    const refs = [dragRef1, dragRef2, dragRef3, dragRef4,dragRef5];
    let lastScrollY = 0;

    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const scrollDown = currentScroll > lastScrollY;
      const rotateValue = window.scrollY / 9;
      refs.forEach((ref, id) => {
        if (ref.current && id === 0) {
          animate(ref.current, {
            rotate: -rotateValue,
          }, { duration: 0.2 });
        }
        if (id === 1) {
          animate(ref.current, {
            y: scrollDown ? '-3rem' : '0rem',
          }, {
            duration: 0.3,
            easing: 'ease-out',
          });
        }
        if (id === 2) {
          animate(ref.current, {
            rotate: rotateValue,
          }, { duration: 0.2 });
        }
        if (id === 3) {
          animate(ref.current, {
            x: scrollDown ? '-3rem' : '0rem',
          }, {
            duration: 0.3,
            easing: 'ease-out',
          });
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);

    };
  }, []);



  // read more functionlity
  const [show,setShow] = useState(false);

  return (
    <>
      <div ref={root}>
        <div className="large centered row">
          <div className='h-[600px] sm:h-[700px] lg:h-[880px]  w-full bg-gradient-to-r from-[#AE51EC] to-[#1C10B8CC] relative overflow-hidden' >
            <div className='flex items-center h-full justify-center flex-col relative'>
              <div className='m-auto w-[90%] md:w-[70%] lg:w-[60%] xl:w-[50%] 2xl:w-[40%] 2xl:mt-[150px] lg:mt-[180px] md:mt-[200px] text-[#F0E3FF] relative z-[3]'>
                <div className='font-semibold  text-xl  sm:text-3xl 2xl:text-3xl   text-center leading-[30px] 2xl:leading-[40px] '>
                  <h5>Empowers Businesses</h5>
                  <h5 >with</h5>
                </div>
                <div className='font-semibold text-2xl text-grey  sm:text-3xl 2xl:text-5xl   text-center leading-[40px] 2xl:leading-[60px]  md:my-6'>
                  <h1>Cutting-Edge Solutions for Digital Success</h1>
                </div>
                <div className='text-center font-normal text-grey  px-3 text-sm  sm:text-md 2xl:text-xl '>
                  {!show ? (
                  <p>At Kalathiya Infotech, we are passionate about helping businesses thrive in the digital landscape. With our comprehensive range of services, cutting-edge technologies, and a team of skilled experts <b className='text-[#F0E3FF] cursor-pointer hover:text-[white] text-nowrap' onClick={()=>{setShow(true)}}><u>Read MOre .....</u></b></p>
                  ):(
                  <p>At Kalathiya Infotech, we are passionate about helping businesses thrive in the digital landscape. With our comprehensive range of services, cutting-edge technologies, and a team of skilled experts, we empower our clients to achieve their goals and elevate their online presence.<br></br><b className='text-[#F0E3FF] cursor-pointer hover:text-[white] text-nowrap' onClick={()=>{setShow(false)}}><u>Read LEss .....</u></b></p>
                    )}
                </div>
                <div className='sp_button flex justify-center z-[2] relative' >
                  <button className='flex justify-center items-center w-[250px] sm:w-[320px] h-[45px] bg-white' onClick={() => { navigate('/contact') }}>
                    <p className='ms-auto  text-md  sm:text-md 2xl:text-xl font-bold  text-transparent bg-clip-text bg-gradient-to-r from-[#AE51EC] to-[#1C10B8CC]'>GET IN TOUCH</p>
                    <div className='w-[34px] h-[34px] bg-[#6230D0] ms-auto flex justify-center items-center rounded-full'>
                      <img src={rightArrow} alt='next'></img>
                    </div>
                  </button>
                </div>
              </div>
              <Wave
                fill="#00000080"
                paused={false}
                style={{ display: 'flex' }}
                options={{
                  height: 100,
                  amplitude: 70,
                  speed: 0.1,
                  points: 7,
                }}
                className="absolute bottom-0 z-1 h-[200px] sm:h-[260px] md:h-[300px] lg:h-[340px] min-w-[1920px]"
              />

              <Wave
                fill="#36407E"
                paused={false}
                style={{ display: 'flex' }}
                options={{
                  height: 80,
                  amplitude: 35,
                  speed: 0.18,
                  points: 8,
                }}
                className="absolute bottom-0 z-1 h-[160px] sm:h-[200px] md:h-[220px] lg:h-[240px] min-w-[1920px]"
              />

              <Wave
                fill="#ffffff"
                paused={false}
                style={{ display: 'flex' }}
                options={{
                  height: 60,
                  amplitude: 25,
                  speed: 0.25,
                  points: 10,
                }}
                className="absolute bottom-0 z-1 h-[100px] sm:h-[120px] md:h-[130px] lg:h-[140px] min-w-[1920px]"
              />
              <img
                ref={dragRef1}
                src={slider1}
                className="sp_slider1 sp_slider"
                alt='image1'
              />
              <img src={slider2}
                ref={dragRef2}
                className='sp_slider2 sp_slider'
                alt='image2' />
              <img
                ref={dragRef3}
                src={slider3} className='sp_slider3 sp_slider' 
                alt='image2' />
              <img
                ref={dragRef4}
                src={slider4} className='sp_slider4 sp_slider' 
                alt='image2' />
              <img
                ref={dragRef5}
                src={slider5} className='sp_slider5 sp_slider' 
                alt='image2' />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
export default Slider
